import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import NavMenu from "./components/NavMenu";
import AuthGuard from './components/AuthGuard';
import theme from './theme';
import { ThemeProvider, CssBaseline } from "@mui/material";
import Login from './pages/Login';
import PrivateRoute from './routing/PrivateRoute';
import Dashboard from "./dashboard/Dashboard";
import CreateAccount from "./pages/CreateAccount";
import AcitvateAccount from "./pages/AcitvateAccount";
import WaitingListForm from "./pages/WaitingListForm";
import ConfirmEmail from "./pages/ConfirmEmail";
import ForgottenPassword from "./pages/ForgottenPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateVenue from "./pages/CreateVenue";
import VenueActivation from "./pages/VenueActivation";
import PaymentComplete from "./pages/PaymentComplete";
import SignupComplete from "./pages/SignupComplete";
import PublicClasses from "./pages/PublicClasses";
import PublicClassesDirectory from "./pages/PublicClassesDirectory";
import VenueSignup from "./pages/VenueSignup";
import MemberSignup from "./pages/MemberSignup";
import Maintenance from "./pages/Maintenance";
import AcceptSubscriptionOffer from "./pages/AcceptSubscriptionOffer";
import PtDirectoryDashboard from "./pages/PtDirectoryDashboard";

const App = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isWaitingList = location.pathname === '/waiting-list';
  const isVenueSignup = location.pathname === '/create-venue';
  const isVenueActivation = location.pathname === '/venue-activation';
  const isPaymentComplete = location.pathname === '/payment-complete';
  const isSignupComplete = location.pathname === '/signup-complete';
  const isPublicClasses = location.pathname === '/classes' || location.pathname.startsWith('/classes/');
  const isUnifiedSignup = location.pathname.startsWith('/signup/');
  const isAcceptOffer = location.pathname.startsWith('/accept-subscription-offer/');
  const isMaintenance = location.pathname === '/maintenance';
  const isMarketing = location.pathname === '/marketing';
  const isPlans = location.pathname === '/plans';
  const isFindPt = location.pathname === '/find-pt' || location.pathname.startsWith('/find-pt/');
  const isPtDirectory = location.pathname === '/pt-directory';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthGuard>
        <main>
          {(!isHomePage && !isWaitingList && !isVenueSignup && !isVenueActivation && !isPaymentComplete && !isSignupComplete && !isPublicClasses && !isUnifiedSignup && !isAcceptOffer && !isMaintenance && !isMarketing && !isPlans && !isFindPt && !isPtDirectory) && <NavMenu />}
          <Layout>
            <Routes>
              <Route path="/maintenance" element={<Maintenance />} />
              <Route path="/login" element={<Login />} />
              <Route path="/create-account" element={<CreateAccount />} />
              <Route path="/forgotten-password" element={<ForgottenPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/acitvate-account" element={<AcitvateAccount />} />
              <Route path="/activate-account" element={<AcitvateAccount />} />
              <Route path="/create-venue" element={<CreateVenue />} />
              <Route path="/venue-activation" element={<VenueActivation />} />
              <Route path="/payment-complete" element={<PaymentComplete />} />
              <Route path="/signup-complete" element={<SignupComplete />} />
              <Route path="/classes" element={<PublicClassesDirectory />} />
              <Route path="/classes/:venueId" element={<PublicClasses />} />
              {/* Venue / PT-Directory signup (WorldsHighStreet service provider) */}
              <Route path="/signup/venue-admin" element={<VenueSignup />} />
              <Route path="/signup/pt-directory" element={<VenueSignup />} />
              {/* Member signup (joining a specific venue) */}
              <Route path="/signup/venue/:venueKey" element={<MemberSignup />} />
              <Route path="/signup/invite/:inviteCode" element={<MemberSignup />} />
              <Route path="/accept-subscription-offer/:inviteCode" element={<AcceptSubscriptionOffer />} />
              <Route path="/pt-directory" element={<PrivateRoute element={<PtDirectoryDashboard />} />} />
              <Route path="/dashboard/*" element={<PrivateRoute element={<Dashboard />} />} />
              <Route path="/waiting-list" element={<WaitingListForm />} />
              {AppRoutes.map((route, index) => {
                const { element, private: isPrivate, ...rest } = route;
                
                return (
                    <Route
                        key={index}
                        {...rest}
                        element={isPrivate !== false ? <PrivateRoute element={element} /> : element}
                    />);
              })}
            </Routes>
          </Layout>
        </main>
      </AuthGuard>
    </ThemeProvider>
  );
};

export default App;
